import React, { useEffect, useState } from 'react';
import { useSessionStore } from '../../hooks/useSessionStore';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import { UsuarioContext } from '../../contexts/UsuarioContext';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';
import './ContentCalendario.css';  // Importar el archivo CSS
import { MenuLateralAB } from "../../components/menuLateralAA/MenuLateralAB";
import Dropdown from 'react-dropdown';
import { Button, Card, Row, Col } from 'react-bootstrap';
import HorasBloqueadasList from './ListadoHorasBloqueadas';
import ToastNotification from '../../hooks/ToastNotification';
import CustomTooltip from '../../hooks/ToolTip';
import { HoraSeleccionar } from '../perfilAgenciaNuevo/HoraSeleccionar';


const ContentCalendario = (props) => {
    const {MenuLateralAux, chageMenuLateralAux} = props;
    const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
    const [empresa, setEmpresa] = useState();
    const [fecha, setFecha] = useState(new Date());
    const [horaInicio, setHoraInicio] = useState('09:00');
    const [modaltitle, setModalTitle] = useState('')
    const [modalMsg, setModalMsg] = useState('')
    const [abrirModal, setAbrirModal] = useState(false)
    const [servicios, setServicios] = useState([]);
    const [ListaServicios, setListaServicios] = useState([]);

    const [mostrarListado, setMostrarListado] = useState(false)
    const [horasBloqueadas, setHorasBloqueadas] = useState()

    const [showToast, setShowToast] = useState(false)
    const [toastType, setToastType] = useState()
    const [toastMsg, setToastMsg] = useState()

    const seleccionarHora = (hora) => {
		console.log('hora', hora)
	};
    
    
    const getDatEmpresa = () => {
        axios({
            method: 'get',
            url: window.ipdirection + 'prestadorServicios/',
            headers: {
                Authorization: 'Bearer ' + Usuario.access,
            },
        }).then((response) => {
            console.log('empresa ', response.data[0]);
            setEmpresa(response.data[0]);
        });
    };

    const get_Servicio_Empresa_Activo = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'get_Servicio_Empresa_Activo/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				setListaServicios([...response.data]);
			})
			.catch((error) => {
				console.log(error);
			});
	};

    const seleccionarServicio = (nombre) => {
        console.log('nombre', nombre)
		// Iteramos sobre cada servicio en la lista de servicios.
		ListaServicios.map((servicio) => {
            console.log('servicio.nombre', servicio.descripcion)
			// Verificamos si el nombre del servicio coincide.
			if (servicio.servicio_id.nombre === nombre) {
                console.log(servicio)
				// Actualizamos el estado de ServicioSeleccionado copiando los atributos del servicio seleccionado.
				setServicios({...setServicios, ...servicio});
			}
		});
	};

    useEffect(() => {
        getDatEmpresa();
        get_Servicio_Empresa_Activo();
    }, []);

    const bloquearHorario = () => {
        let data = {
                fechaServicio: fecha.toISOString().split('T')[0],
                servicio_empresa: servicios.id,
                hora_inicio: horaInicio,
            };
      axios({
        method: 'post',
        url: window.ipdirection + 'servicioEmpresaVacioEmpresa/',
        headers: {
          Authorization: 'Bearer ' + Usuario.access,
        },
        data: data,
      }).then(response => {
              console.log(response.data);
              setToastType('success')
              setToastMsg('Hora bloqueada correctamente')
              setShowToast(true);
              setHoraInicio('')
              setFecha(new Date())
              setServicios('')
      }).catch(error => {
              console.error(error);
              setToastType('error')
              setToastMsg('Error al bloquear la hora');
              setShowToast(true);
              setHoraInicio('')
              setFecha(new Date())
              setServicios('')
      });
    };

  useEffect(()=>{
      axios({
        method: 'get',
        url:
          window.ipdirection +
          'horasBloqueadas/?servicio_empresa_id=' +
          servicios.id +
          '&dia=' +
          fecha.toISOString().slice(0, 10)
      })
        .then((response) => {
          setHorasBloqueadas(response.data.HorasCogidas);
        })
        .catch((error) => {
          console.log(error);
        });
  },[servicios, fecha])

    return (
    //     <div className='calendario-body'>
    //         <MenuLateralAB seleccionado={2} MenuLateralAux={MenuLateralAux} chageMenuLateralAux={chageMenuLateralAux} />
    //         <div className='headContentUsuarios'>
    //             <div className='superiorHeadContentUsuarios'>
    //                 <div>
    //                     <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
    //                 </div>
    //                 <div className='centrador titleHeadHistorialFacturas'>
    //                     <b>Calendario</b>
    //                 </div>
    //             </div>
    //             <div className='separador'></div>
    //             <div className='menuPresupuestos BotonesSuperiorPresupuestos '>
	// 				<div className='buttonNotificacionesActive'>
	// 					<div className='centrador'>Bloquear Hora</div>
	// 				</div>
    //             </div>
    //         </div>
    //         <div className='calendario-container-body'>
    //             <div className="calendario-container">
    //                 <h2 className="calendario-title">Bloquear Horario</h2>
    //                 <div className="calendario-form">
    //                     <label className="calendario-label">Seleccionar fecha:</label>
    //                     <input
	// 						className='inputTextUsuario'
	// 						type='date'
	// 						value={getFecha()}
	// 						min={new Date().toISOString().substr(0, 10)} // Deshabilitar fechas anteriores a hoy
	// 						onChange={(e) => setFecha(new Date(e.target.value))}
	// 					/>
    //                     {/* <DatePicker 
    //                         selected={fecha} 
    //                         onChange={(e) => setFecha(e.target.value)} 
    //                         minDate={fecha}  // Deshabilitar fechas anteriores a hoy
    //                         className="calendario-datepicker" 
    //                     /> */}
    //                     <label className="calendario-label">Hora de inicio:</label>
    //                     <input 
    //                         type="time" 
    //                         value={horaInicio} 
    //                         onChange={e => setHoraInicio(e.target.value)} 
    //                         className="calendario-timepicker" 
    //                     />
    //                     <label className="calendario-label">Servicio:</label>
    //                     {
    //                         ListaServicios.length === 0 ?
    //                             <div className="calendario-servicios">No hay servicios disponibles</div>
    //                         :
    //                         <Dropdown
    //                             className='calendario-datepicker'
    //                             options={ListaServicios.map((servicio) => {
    //                                 return servicio.descripcion;
    //                             })}
    //                             onChange={(e) => seleccionarServicio(e.value)}
    //                             value={servicios.nombre}
    //                             placeholder={'-- Selecionar --'}
    //                         />
    //                     }
    //                     <button onClick={bloquearHorario} className="calendario-button">Bloquear Horario</button>
    //                 </div>
    //             </div>
    //         </div>
    //         <Modal
    //             centered={true}
    //             isOpen={abrirModal}
    //         >
    //             <ModalHeader>
    //                 <div className='titulo-modal'>{modaltitle}</div>
    //             </ModalHeader>
    //             <ModalBody>
    //                 <div className='descripcion-servicio descripcion-modal'>
    //                     {modalMsg}
    //                 </div>
    //             </ModalBody>
    //             <ModalFooter>
    //                 <div className='centrador'>
    //                     <div
    //                         className='button'
    //                         onClick={() => setAbrirModal(false)}
    //                     >
    //                         <b>Cerrar</b>
    //                     </div>
    //                 </div>
    //             </ModalFooter>
    //         </Modal>
    // </div>
    <div className="">
        <MenuLateralAB seleccionado={2} MenuLateralAux={MenuLateralAux} chageMenuLateralAux={chageMenuLateralAux} />
      <div className="headContentUsuarios">
        <div className="superiorHeadContentUsuarios columnas3">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
          </div>
          <div className="centrador titleHeadHistorialFacturas">
            <b>Gestiona tu disponibilidad</b>
          </div>
          <CustomTooltip textContent={"Indica los dias y horas en los que no estes disponible para que no se puedan programar servicios."}/>
        </div>

        <div className="separador"></div>

        {/* Menú superior */}
        <div className="menuPresupuestos BotonesSuperiorPresupuestos">
          <div
            className={`${!mostrarListado ? 'buttonNotificacionesActive ' : 'buttonNotificaciones'}`}
            onClick={() => setMostrarListado(false)}
          >
            <div className="centrador">Bloquear Hora</div>
          </div>
          <div
            className={`${mostrarListado ? 'buttonNotificacionesActive' : 'buttonNotificaciones'}`}
            onClick={() => setMostrarListado(true)}
          >
            <div className="centrador">Ver Horas Bloqueadas</div>
          </div>
        </div>
      </div>

      {/* Contenido dinámico */}
      <div className="calendario-container-body container">
        {!mostrarListado ? (
          <div className="calendario-form">
            <h5 className="mb-3">Bloquear Horario</h5>

            <div className="mb-3">
              <label className="form-label">Servicio:</label>
              <select
                className="form-select"
                value={servicios.nombre}
                onChange={(e) => seleccionarServicio(e.target.value)}
              >
                <option value="">-- Seleccionar --</option>
                {ListaServicios.map((s, i) => (
                  <option key={i} value={s.servicio_id.nombre}>
                    {s.servicio_id.nombre}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Seleccionar fecha:</label>
              <input
                className="form-control text-dark"
                type="date"
                value={fecha.toISOString().split('T')[0]}
                min={new Date().toISOString().split('T')[0]}
                onChange={(e) => setFecha(new Date(e.target.value))}
              />
            </div>

            {
              horasBloqueadas && (
                <div className="container">
                  <div className="row">
                    {horasBloqueadas.map((hora, index) => (
                      <div className="col-6 mb-2" key={index}>
                        <button
                          className={`btn w-100 ${hora === horaInicio ? "btn-primary" : "btn-outline-secondary"}`}
                          onClick={() => setHoraInicio(hora)}
                        >
                          {hora}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )
            }

            <Button onClick={bloquearHorario} variant="primary" className='login-boton'>
              Bloquear Horario
            </Button>
          </div>
        ) : (
          <HorasBloqueadasList horasBloqueadas={horasBloqueadas} ListaServicios={ListaServicios} />
        )}
      </div>
      <ToastNotification
        message={toastMsg}
        show={showToast}
        onClose={() => setShowToast(false)}
        type={toastType}
      />
    </div>
    );
};

export default ContentCalendario;